import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import SingleCalendar from 'Components/SingleCalendar';
import DateIcon from 'Components/icons/DateIcon';
import OptionBoxPopup from 'Components/OptionBoxPopup';
import TextField from 'Components/forms/text-field/TextField';

import '../_ranges.scss';
import '../_datepicker.scss';
import './SingleDateInput.scss';
import { COLORS } from "Constants/BIDashboardConstants"

class SingleDateInput extends Component {
  constructor(props) {
    super(props);

    const validatedDateFormat = ['MM/DD/YYYY', 'DD/MM/YYYY'].includes(props.dateFormat)
      ? props.dateFormat
      : 'MM/DD/YYYY';

    const triggerText = this.getTriggerText(props.singleDate, validatedDateFormat);

    this.state = {
      dateFormat: validatedDateFormat,
      triggerText,
      right: false,
    };

    this.attachBindings();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.singleDate !== this.props.singleDate ||
      newProps.dateFormat !== this.props.dateFormat) {
      const validatedDateFormat = ['MM/DD/YYYY', 'DD/MM/YYYY'].includes(newProps.dateFormat)
        ? newProps.dateFormat
        : 'MM/DD/YYYY';

      const triggerText = this.getTriggerText(newProps.singleDate, validatedDateFormat);

      this.setState({
        dateFormat: validatedDateFormat,
        triggerText,
      });
    }
  }

  componentDidMount() {
    // this.setPosition();
  }

  getTriggerText(singleDate, currentFormat) {
    if (!singleDate || singleDate === '') {
      return this.props.translations.unselectedText;
    }

    const formattedDate = moment(singleDate).format(currentFormat);

    return formattedDate;
  }

  get labelContent() {
    return (
      <span style={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}`}}>
        {this.props.title}
        {this.props.error && <span className="message-error">{this.props.error}</span>}
      </span>
    );
  }

  applyDate(id, singleDate) {
    this.optionsBoxPopup && this.optionsBoxPopup.toggle();
    this.props.onApply(id, singleDate);
  }

  attachBindings() {
    this.applyDate = this.applyDate.bind(this);
  }

  setPosition = () => {
    const el = document.querySelector('.dual-date-input');
    const bounds = el && el.getBoundingClientRect();
    const halfWindowWidth = window.innerWidth / 2;

    if (bounds) {
      if (bounds.x > halfWindowWidth) {
        this.setState({
          right: true,
        });
      }
    }
  }

  render() {
    const htmlId = `${this.props.title.replace(/ /, '-')}-${this.props.id}`;

    return (
      <TextField
        error={this.props.error}
        fieldClass="field range-container dual-date-input"
        htmlFor={htmlId}
        labelContent={this.labelContent}
        isRequired={this.props.isRequired}
      >
        <OptionBoxPopup
          translations={this.props.translations}
          icon={DateIcon}
          triggerText={this.state.triggerText}
          ref={(ref) => { this.optionsBoxPopup = ref; }}
          right={this.state.right}
        >
          <SingleCalendar
            singleDate={this.props.singleDate}
            id={this.props.id}
            minDate={this.props.minDate}
            maxDate={this.props.maxDate}
            onApply={this.applyDate}
            onRef={(ref) => (this.child = ref)}
            dateFormat={this.state.dateFormat}
            translations={this.props.translations}
          />
        </OptionBoxPopup>
      </TextField>
    );
  }
}

SingleDateInput.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  error: PropTypes.string,
  minDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  singleDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  onApply: PropTypes.func.isRequired,
  title: PropTypes.string,
  dateFormat: PropTypes.string,
  translations: PropTypes.object,
  isRequired: PropTypes.bool
};

SingleDateInput.defaultProps = {
  singleDate: '',
  error: '',
  title: '',
  dateFormat: 'MM/DD/YYYY',
  translations: {
    unselectedText: 'Select Date',
    validDateError: 'Please enter a valid date.',
  },
  isRequired: false
};

export default SingleDateInput;
